export const sliceText = (text: string, length?: number) => {
  if (text?.length > (length || 12)) {
    return text?.slice(0, length || 12)?.concat('...');
  }

  return text;
};
